<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="mapEnrollmentsStatics"
    class="m-students-statics"
  >
    <div class="m-card-primary m-card-static">
      <h3>Alumnos inscriptos</h3>
      <div class="display-flex-row-center">
        <div role="circle-progress-map"
          :aria-valuenow="statics.progreso_alumnos.porcentaje_alumnos_activos_proyecto"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="`--value:${statics.progreso_alumnos.porcentaje_alumnos_activos_proyecto}`">
          {{ statics.progreso_alumnos.porcentaje_alumnos_activos_proyecto }}%
        </div>
        <span class="display-flex-row-center margin-left-xxlarge">
          <span class="margin-right-xsmall text-color-maps-primary">&#9679;</span>
          <span v-if="statics.progreso_alumnos.alumnos_activos_proyecto === 1">
            {{ statics.progreso_alumnos.alumnos_activos_proyecto }} Alumno
          </span>
          <span v-else>
            {{ statics.progreso_alumnos.alumnos_activos_proyecto }} Alumnos
          </span>
        </span>
      </div>
      <small class="display-block text-color-black-45 margin-top-large">
        <i>Respecto a {{ statics.progreso_alumnos.alumnos_activos_academia }} alumnos de la academia</i>
      </small>
    </div>

    <div class="m-card-primary m-card-static">
      <h3>Comenzaron el mapa</h3>
      <div class="display-flex-row-center">
        <div role="circle-progress-map"
          :aria-valuenow="statics.progreso_alumnos.porcentaje_alumnos_iniciaron_proyecto"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="`--value:${statics.progreso_alumnos.porcentaje_alumnos_iniciaron_proyecto}`">
          {{ statics.progreso_alumnos.porcentaje_alumnos_iniciaron_proyecto }}%
        </div>
        <span class="display-flex-row-center margin-left-xxlarge">
          <span class="margin-right-xsmall text-color-maps-primary">&#9679;</span>
          <span v-if="statics.progreso_alumnos.alumnos_iniciaron_proyecto === 1">
            {{ statics.progreso_alumnos.alumnos_iniciaron_proyecto }} Alumno
          </span>
          <span v-else>
            {{ statics.progreso_alumnos.alumnos_iniciaron_proyecto }} Alumnos
          </span>
        </span>
      </div>
    </div>

    <div class="m-card-primary m-card-static">
      <h3>Finalizaron el mapa</h3>
      <div class="display-flex-row-center">
        <div role="circle-progress-map"
          :aria-valuenow="statics.progreso_alumnos.porcentaje_alumnos_terminaron_proyecto"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="`--value:${statics.progreso_alumnos.porcentaje_alumnos_terminaron_proyecto}`">
          {{ statics.progreso_alumnos.porcentaje_alumnos_terminaron_proyecto }}%
        </div>
        <span class="display-flex-row-center margin-left-xxlarge">
          <span class="margin-right-xsmall text-color-maps-primary">&#9679;</span>
          <span v-if="statics.progreso_alumnos.alumnos_completaron_proyecto === 1">
            {{ statics.progreso_alumnos.alumnos_completaron_proyecto }} Alumno
          </span>
          <span v-else>
            {{ statics.progreso_alumnos.alumnos_completaron_proyecto }} Alumnos
          </span>
        </span>
      </div>
    </div>
  </div>
  </template>

<script>
export default {
  name: 'MoleculeEditionMapEnrollmentsStatics',

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      showLoadingState: true,
      statics: {}
    }
  },

  created () {
    this.readInscripcionesProyecto()
  },

  methods: {
    readInscripcionesProyecto () {
      this.$services.read('proyecto', 'readProyectoProgresoAlumnos', {}, [this.element.id])
        .then(response => {
          this.statics = response.data
          console.log(this.statics)
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    }
  }
}
</script>
